import { Box, Button, Typography } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { AuthTextField } from "./TextField";
import { z } from "zod";

export const mfaSchema = z.object({
    mfaCode: z.string().min(1, "MFA code is required")
});

export type MfaFormData = z.infer<typeof mfaSchema>;

interface MfaFormProps {
    onSubmit: (data: MfaFormData) => void;
    onBack: () => void;
}

export default function MfaForm({ onSubmit, onBack }: MfaFormProps) {
    const methods = useForm<MfaFormData>({
        resolver: zodResolver(mfaSchema),
        mode: "onChange"
    });
    const { formState } = methods;

    return (
        <FormProvider {...methods}>
            <Box component="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <Typography variant="h4" textAlign="center" gutterBottom color="primary">
                    Enter MFA Code
                </Typography>
                <AuthTextField
                    name="mfaCode"
                    label="MFA Code"
                    placeholder="Enter your MFA code"
                    fullWidth
                    margin="normal"
                />
                <Button variant="contained" type="submit" fullWidth sx={{ mt: 2 }} disabled={!formState.isValid}>
                    Submit
                </Button>
            </Box>
        </FormProvider>
    );
}
